module.exports = __webpack_public_path__ + "a912777e67d6b7b6782802c2e459e09f.jpg";